import { projectSlice } from './slice'

/* Create Project */
export const { setCreateProjectResponse } = projectSlice.actions
export const { setCreateProjectLoading } = projectSlice.actions
export const { setCreateProjectSuccess } = projectSlice.actions
export const { resetProjectCreateState } = projectSlice.actions
export const { resetProjectCreateAllState } = projectSlice.actions

/* Validate Project Id */
export const { setValidateProjectIdLoading } = projectSlice.actions
export const { setValidateProjectIdResponse } = projectSlice.actions
export const { resetValidateProjectId } = projectSlice.actions

/* Validate Project Id For Stock Sale*/
export const { setValidateProjectIdForStockSaleLoading } = projectSlice.actions
export const { setValidateProjectIdForStockSaleResponse } = projectSlice.actions
export const { resetValidateProjectIdForStockSale } = projectSlice.actions

/* Purchase Brokerage Operation */
export const { setPurchaseOperationLoading } = projectSlice.actions
export const { setPurchaseOperationSuccess } = projectSlice.actions
export const { setBrokerageOperationNewLink } = projectSlice.actions
export const { setPurchaseOperationError } = projectSlice.actions
export const { resetPurchaseOperationSuccess } = projectSlice.actions

/* Purchase Brokerage Operation */
export const { setBrokerageOperationLoading } = projectSlice.actions
export const { setBrokerageOperationSuccess } = projectSlice.actions
export const { setBrokerageOperationError } = projectSlice.actions
export const { resetBrokerageOperationState } = projectSlice.actions

// User Projects Reducers
export const { setUserProjectsLoading } = projectSlice.actions
export const { setUserProjectsData } = projectSlice.actions
export const { resetUserProjectsState } = projectSlice.actions
export const { setUserProjectsFilterText } = projectSlice.actions
export const { setUserProjectsFilterType } = projectSlice.actions

// Project Details Reducers
export const { setProjectDetailsLoading } = projectSlice.actions
export const { setProjectDetailsData } = projectSlice.actions
export const { resetProjectDetailsState } = projectSlice.actions

/* Transfer Project Reducers */
export const { setTransferProjectLoading } = projectSlice.actions
export const { setTransferProjectSuccess } = projectSlice.actions
export const { setTransferProjectError } = projectSlice.actions
export const { resetTransferProjectState } = projectSlice.actions

/* Project Form Reducers */
export const { setProjectFormItemValue } = projectSlice.actions
// Create Big Project Reducers
export const { setCreateBigProjectLoading } = projectSlice.actions
export const { setCreateBigProjectNewId } = projectSlice.actions
export const { setCreateBigProjectError } = projectSlice.actions
export const { resetCreateBigProjectState } = projectSlice.actions

// Definition
export const { resetProjectFormState } = projectSlice.actions
export const { restFormKindChanged } = projectSlice.actions
// Content
export const { setProjectFormContentValues } = projectSlice.actions
// Tax Description Section
export const { setProjectFormTaxDescriptionsValue } = projectSlice.actions
// Certification Sections
export const { setCertificationFormValues } = projectSlice.actions
// Documentation Section
export const { setDocumentationPayload } = projectSlice.actions
export const { setBillingPayloadForCreate } = projectSlice.actions
// Edit Project Form Reducers
export const { setFormDataValues } = projectSlice.actions
export const { setEditBigProjectLoading } = projectSlice.actions
export const { setEditBigProjectSuccess } = projectSlice.actions
export const { setEditBigProjectError } = projectSlice.actions
export const { resetEditBigProjectState } = projectSlice.actions
